module.exports = __webpack_public_path__ + "img/guangzhou.d0db26fc.png";